import axios from "axios";

export const Axios = axios.create({
  // dev

  // baseURL: "https://api_test.zooza.sk/v1_test",
  // headers: {
  //   "X-ZOOZA-API-KEY": "as43gjrvnr597",
  //   "X-ZOOZA-COMPANY": "1",
  // },

  // prod

  baseURL: "https://api.zooza.app/v1",
  headers: {
    "X-ZOOZA-API-KEY": "F3gjb7hrfh",
    "X-ZOOZA-COMPANY": "1",
  },
});
